// native
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

// addon
import { Subscription } from 'rxjs';

// service
import { ToastService } from '../../services/toast.service';

// model
import { ToastButton } from '../../../models';

@Component({
  selector: 'scs-toast',
  templateUrl: './toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastComponent implements OnInit, OnDestroy {

  isVisible: boolean = false;
  text: string;
  type: string;
  confirmButton: ToastButton;
  cancelButton: ToastButton;
  isCloseDisabled: boolean;
  isFullScreen: boolean;
  isCentered: boolean;

  visibilitySubscription: Subscription;
  textSubscription: Subscription;
  typeSubscription: Subscription;
  confirmButtonSubscription: Subscription;
  cancelButtonSubscription: Subscription;
  closeDisabledSubscription: Subscription;
  fullScreenSubscription: Subscription;
  centeredSubscription: Subscription;

  constructor(
    private toastService: ToastService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.visibilitySubscription = this.toastService.visibility$
      .subscribe((status: boolean) => {
        this.isVisible = status;
        this.changeDetectorRef.markForCheck();
      });

    this.textSubscription = this.toastService.text$
      .subscribe((text: string) => {
        this.text = text;
        this.changeDetectorRef.markForCheck();
      });

    this.typeSubscription = this.toastService.type$
      .subscribe((type: string) => {
        this.type = type;
        this.changeDetectorRef.markForCheck();
      });

    this.confirmButtonSubscription = this.toastService.confirmButton$
      .subscribe((confirmButton: any) => {
        this.confirmButton = confirmButton;
        this.changeDetectorRef.markForCheck();
      });

    this.cancelButtonSubscription = this.toastService.cancelButton$
      .subscribe((cancelButton: any) => {
        this.cancelButton = cancelButton;
        this.changeDetectorRef.markForCheck();
      });

    this.closeDisabledSubscription = this.toastService.closeDisabled$
      .subscribe((isCloseDisabled: boolean) => {
        this.isCloseDisabled = isCloseDisabled;
      });

    this.fullScreenSubscription = this.toastService.isFullScreen$
      .subscribe((isFullScreen: boolean) => {
        this.isFullScreen = isFullScreen;
      });

    this.centeredSubscription = this.toastService.isCentered$
      .subscribe((isCentered: boolean) => {
        this.isCentered = isCentered;
      });
  }

  ngOnDestroy() {
    this.visibilitySubscription?.unsubscribe();
    this.textSubscription?.unsubscribe();
    this.typeSubscription?.unsubscribe();
    this.confirmButtonSubscription?.unsubscribe();
    this.cancelButtonSubscription?.unsubscribe();
    this.closeDisabledSubscription?.unsubscribe();
    this.fullScreenSubscription?.unsubscribe();
    this.centeredSubscription?.unsubscribe();
  }

  onClose() {
    this.hide();
  }

  onConfirmClick() {
    this.confirmButton.callback();
    this.onClose();
  }

  onCancelClick() {
    this.cancelButton.callback();
    this.onClose();
  }

  private hide() {
    this.isVisible = false;
    this.changeDetectorRef.markForCheck();
  }
}
